import React, { Component } from "react";
import { messages } from "../../i18n-messages";
import { InjectedIntlProps } from "react-intl";
import { createAddLinkLabelText, createAddEditModalTitle } from "~/i18n-messages";
// Components
import { TextInput, DialogBox, DialogBoxFooterType, NoLink, ZeroToInfiniteGrid } from "~/core";
import { withEditableGrid } from "~/hocs";
//Types
import { ITraitGeneProps, ITraitGeneState } from "../interfaces";

// Constants
const PROPS_TRAIT_EVENT = "eventName";

class TraitEvents extends Component<ITraitGeneProps & InjectedIntlProps, ITraitGeneState> {
    constructor(props) {
        super(props);
        this.state = {
            editingItem: false,
        };
    }

    onEdit = (record, index) => {
        const keysToUpdate = [PROPS_TRAIT_EVENT];
        this.setState({ editingItem: true });
        this.props.onEdit({ record, index, keysToUpdate });
    };

    onDelete = (record, index) => {
        this.props.onDelete({ record, index });
    };

    onAdd = () => {
        this.setState({ editingItem: false });
        this.props.onAdd();
    };

    renderAddEditModal = () => {
        const { formatMessage, isEditing, editData, onAddOrEditItem, onChange, toggleModal } =
            this.props;
        const formData = { ...editData };
        return (
            <DialogBox
                footerType={DialogBoxFooterType.ACTION_CANCEL}
                isOpen={isEditing}
                actionDisabled={!editData[PROPS_TRAIT_EVENT]}
                onAction={() => onAddOrEditItem()}
                onClose={() => toggleModal("isEditing", false)}
                title={createAddEditModalTitle(
                    this.state.editingItem,
                    formatMessage,
                    messages.traitEvent
                )}
                action="save"
            >
                <TextInput
                    tabIndex={0}
                    maxLength={50}
                    autoFocus
                    placeholderText={formatMessage(messages.traitEvent, {
                        count: 0,
                    })}
                    value={formData[PROPS_TRAIT_EVENT] || ""}
                    onChange={(value) =>
                        onChange({
                            [PROPS_TRAIT_EVENT]: value,
                        })
                    }
                />
            </DialogBox>
        );
    };

    render() {
        const { record, formatMessage, renderDeleteModal } = this.props;
        return (
            <div className={"form-section-child-stretch mini-grid"}>
                {record && record.length > 0 && (
                    <ZeroToInfiniteGrid
                        records={record}
                        columns={{
                            [PROPS_TRAIT_EVENT]: {
                                title: formatMessage(messages.name),
                            },
                        }}
                        onEdit={this.onEdit}
                        onDelete={this.onDelete}
                        showHeader={false}
                    />
                )}
                {this.renderAddEditModal()}
                {renderDeleteModal()}
                <div className="add-link-container">
                    <NoLink
                        className="add-link"
                        label={createAddLinkLabelText(formatMessage, messages.traitEvent)}
                        onClick={this.onAdd}
                    ></NoLink>
                </div>
            </div>
        );
    }
}

export default withEditableGrid(TraitEvents);
